import React, { FC } from "react";
import DashboardTile from "@components/Home/DashboardTile/DashboardTile";
import {
  Avatar,
  Box,
  Button,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@store/store";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import { useNavigate } from "react-router-dom";
import { ScreenSize } from "@constants/screen-size";
import ForwardToInboxOutlinedIcon from "@mui/icons-material/ForwardToInboxOutlined";
import { setOpen } from "@store/inviteSlice";
import ModeSwitch from '@components/ModeSwitch/ModeSwitch';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

const StyledButton = styled(Button)`
  display: flex;
  gap: 6px;
`;

const GhostLoader: FC = () => {
  return (
    <Box display="flex" gap="16px">
      <Skeleton variant="circular" width="109px" height="109px" />
      <Skeleton variant="rectangular" height="109px" sx={{ flex: 1 }} />
    </Box>
  );
};

const PatientProfileTile: FC = () => {
  const patient = useSelector((state: RootState) => state.home.selectedPatient);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const editProfile = () => {
    navigate("/patient-info");
  };

  const openInviteDialog = () => {
    dispatch(setOpen(true));
  };

  return (
    <>
      <DashboardTile filled={true}>
        {patient ? (
          <Content>
            <Avatar
              sx={{ height: "88px", width: "88px" }}
              src={patient.avatarUrl}
            />

            <Stack alignItems="center" gap="8px">
              <Typography variant="h6" color="textSecondary" fontWeight="500">
                {patient.firstName}
              </Typography>
              <StyledButton
                variant="contained"
                size="small"
                onClick={editProfile}
                id="edit-profile-button"
              >
                <span>{t("dashboard.patientProfile.editInfoButton")}</span>
                <ModeEditOutlineOutlinedIcon />
              </StyledButton>
            </Stack>

            <Buttons>
              <ModeSwitch />
              <StyledButton
                variant="outlined"
                color="error"
                size="medium"
                fullWidth
                onClick={openInviteDialog}
                sx={{ backgroundColor: "#fff" }}
                id="invite-patient-button"
              >
                <span>{t("dashboard.patientProfile.inviteButton")}</span>
                <ForwardToInboxOutlinedIcon />
              </StyledButton>
            </Buttons>
          </Content>
        ) : (
          <GhostLoader />
        )}
      </DashboardTile>
    </>
  );
};

export default PatientProfileTile;
